module.exports = __webpack_public_path__ + "img/search.4f41a660.svg";